import styled, { keyframes } from "styled-components";


interface IProps {
  isOpen?: boolean
}

const Anima = keyframes`
  from{
    opacity: 0
  }to{
    opacity: 1;
  }
`


export const Version = styled.span`
  position: absolute;
  bottom: 10px;
  text-align: center;
  color: #fff;
  align-self: center;
  font-size: .69rem;
`



export const Container = styled.div<IProps>`
  grid-area: aside;
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${props => props.theme.colors.darkSilver};
  transition: all .3s;
  @media(max-width: 700px){
    position: absolute;
    left: 0;
    z-index: 1002;
    height: 100vh;
  }
  ${({ isOpen }) => {
    if (isOpen) {
      return (`
      width: 320px;
    
    `)
    }
    return (`
      width: 50px;
      
      
      @media(max-width: 700px){
        width: 0;
        > div {
          opacity: 0;
        }
      }
    `)
  }}
`


export const CompanyContainer = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center; 
  padding: 18px 0;
  animation: ${Anima} 2s  forwards;
  >span{
    color: #fff;
    font-size: .69rem;
    margin-top: 8px;
  }
`

export const LogoContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
 
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  display: flex;
  justify-content: center;
  align-items: center; 
  overflow: hidden;
  >img{
    max-width: 100%;
    max-height: 100%;
  }
`

export const CompanyName = styled.h1<IProps>`
  
  font-weight: 700;
  font-size: 1rem;
  color:${props => props.theme.colors.white};
  margin-top: 10px;
 
  
  ${({ isOpen }) => {
    if (isOpen) {
      return `display: block`
    } else {
      return `display: none`
    }
  }}

`

export const MenuList = styled.ul``